import React from 'react';
import { motion } from 'framer-motion';

const GamifiedProgress = ({ current, total, region }) => {
  const percentage = Math.round((current / total) * 100);
  
  return (
    <div className="w-full max-w-2xl mx-auto mb-8">
      <div className="flex justify-between items-end mb-2">
        <div className="flex flex-col">
          <span className="text-xs font-bold text-brand-crimson uppercase tracking-widest mb-1">
            Current Neural Pathway
          </span>
          <span className="text-xl font-bold text-brand-coffee font-luxe">
            {region}
          </span>
        </div>
        <div className="text-right">
          <span className="text-2xl font-black text-brand-crimson font-manrope">
            {percentage}%
          </span>
          <p className="text-xs text-brand-coffee/60">Neural Map Complete</p>
        </div>
      </div>
      
      <div className="relative h-4 w-full bg-brand-dust/30 rounded-full overflow-hidden border border-brand-dust">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          className="absolute inset-y-0 left-0 bg-gradient-to-r from-brand-crimson via-brand-rose to-brand-golden shadow-[0_0_15px_rgba(102,2,60,0.4)]"
        />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10" />
      </div>
      
      <div className="flex justify-between mt-2">
        <div className="flex gap-1">
          {[...Array(5)].map((_, i) => (
            <div 
              key={i} 
              className={`w-3 h-1 rounded-full ${i < Math.floor(percentage/20) ? 'bg-brand-golden' : 'bg-brand-dust'}`}
            />
          ))}
        </div>
        <span className="text-[10px] font-bold text-brand-coffee/40 uppercase">
          Mapping 86 Billion Neurons...
        </span>
      </div>
    </div>
  );
};

export default GamifiedProgress;